import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import {
  DeleteEdgeLocationDialog,
  DeleteEdgeLocationDialogProps,
} from './DeleteEdgeLocationDialog';

import { ShowModalOutput } from '@cast/design-system';

export const useDeleteEdgeLocationDialog = () => {
  const { showModal } = useModal();

  const modalInstance = useRef<ShowModalOutput>(undefined);

  return {
    openDeleteEdgeLocationDialog: ({
      edgeLocation,
      clusterId,
    }: DeleteEdgeLocationDialogProps) => {
      modalInstance.current = showModal(DeleteEdgeLocationDialog, {
        edgeLocation,
        clusterId,
        onClose: () => modalInstance.current?.destroy(),
      });
    },
  };
};
